import React from "react";

const SearchIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.237 13.795L8.01902 8.57703C7.60235 8.93173 7.12318 9.2063 6.58152 9.40074C6.03985 9.59518 5.49551 9.69241 4.9485 9.69241C3.61377 9.69241 2.48416 9.2304 1.55964 8.30639C0.635115 7.38237 0.172852 6.25336 0.172852 4.91936C0.172852 3.58536 0.634858 2.45549 1.55887 1.52974C2.48289 0.603988 3.61189 0.141113 4.94589 0.141113C6.27991 0.141113 7.40978 0.60337 8.33552 1.52788C9.26127 2.4524 9.72414 3.58202 9.72414 4.91676C9.72414 5.49582 9.62158 6.05618 9.41646 6.59784C9.21133 7.13951 8.9421 7.60266 8.60877 7.98728L13.8267 13.2052L13.237 13.795ZM4.9485 8.85907C6.05427 8.85907 6.98777 8.47846 7.74898 7.71724C8.5102 6.95602 8.89081 6.02252 8.89081 4.91676C8.89081 3.811 8.5102 2.8775 7.74898 2.11628C6.98777 1.35506 6.05427 0.974447 4.9485 0.974447C3.84273 0.974447 2.90924 1.35506 2.14802 2.11628C1.38681 2.8775 1.00621 3.811 1.00621 4.91676C1.00621 6.02252 1.38681 6.95602 2.14802 7.71724C2.90924 8.47846 3.84273 8.85907 4.9485 8.85907Z"
        fill="white"
      />
    </svg>
  );
};

export default SearchIcon;
